import React, { useState, useEffect, useContext } from 'react';
import { useHistory } from "react-router-dom";
import QRCode from 'react-qr-code';
import { SuccessContent, Total } from './style';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { FaCopy, FaCheckCircle } from 'react-icons/fa';
import { socketConnection } from "../../../services/socket";
import { useDate } from "../../../hooks/useDate";
import { toast } from "react-toastify";
import { AuthContext } from '../../../context/Auth/AuthContext';
import { SocketContext } from '../../../context/Socket/SocketContext';

function CheckoutSuccess(props) {

  const { pix } = props;
  const socketManager = useContext(SocketContext);
  const [pixString,] = useState(pix?.qrcode?.qrcode || '');
  const [stripeURL,] = useState(pix.stripeURL);
  const [asaasCardURL,] = useState(pix.asaasCardURL || pix.asaasURL);
  const [asaasPixURL,] = useState(pix.asaasPixURL);
  const [mercadopagoURL,] = useState(pix.mercadopagoURL);
  const [valorext,] = useState(pix.valorext);
  const [copied, setCopied] = useState(false);
  const history = useHistory();

  const { dateToClient } = useDate();
  const { user, socket } = useContext(AuthContext);

  const companyId = user.companyId;

  useEffect(() => {
    if (!socket) return;
    const onCompanyPayment = (data) => {
      if (data.action === "CONCLUIDA") {
        toast.success(`Sua licença foi renovada até ${dateToClient(data.company.dueDate)}!`);
        setTimeout(() => {
          history.push("/");
        }, 4000);
      }
    }
    socket.on(`company-${companyId}-payment`, onCompanyPayment);

    return () => {
      socket.off(`company-${companyId}-payment`, onCompanyPayment);
    }
  }, [socket, history, dateToClient, companyId]);

  const handleCopyQR = () => {
    setTimeout(() => {
      setCopied(false);
    }, 1 * 1000);
    setCopied(true);
  };

  const btnBase = {
    border: 'none',
    padding: '14px 28px',
    fontSize: '16px',
    width: '100%',
    cursor: 'pointer',
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    fontWeight: '700',
    borderRadius: '10px',
    marginBottom: 10,
  };

  return (
    <React.Fragment>

      {/* Branded header */}
      <div style={{ textAlign: 'center', padding: '20px 16px 12px', borderBottom: '1px solid #eee', marginBottom: 20 }}>
        <img src="/logo.png" alt="Estratiza Hub" style={{ height: 50, marginBottom: 10, objectFit: 'contain', display: 'block', margin: '0 auto 10px' }} />
        <div style={{ fontSize: '0.78rem', color: '#999', marginBottom: 2, textTransform: 'uppercase', letterSpacing: 1 }}>
          {user?.company?.name || 'Estratiza Hub'}
        </div>
        <div style={{ fontSize: '1.05rem', fontWeight: 700, color: '#333', marginBottom: 6 }}>
          Assinatura {user?.company?.plan?.name || ''}
        </div>
        <div style={{ fontSize: '1.6rem', fontWeight: 800, color: '#3c6afb' }}>
          R$ {valorext && valorext.toLocaleString ? valorext.toLocaleString('pt-br', { minimumFractionDigits: 2 }) : valorext}
          <span style={{ fontSize: '0.85rem', fontWeight: 400, color: '#888' }}> /mês</span>
        </div>
      </div>

    <SuccessContent>

  	{pixString && (
    <>

    <QRCode value={pixString} />
    <CopyToClipboard text={pixString} onCopy={handleCopyQR}>
      <button className="copy-button" type="button">
        {copied ? (
          <>
            <span>Copiado</span>
            <FaCheckCircle size={18} />
          </>
        ) : (
          <>
            <span>Copiar código QR PIX</span>
            <FaCopy size={18} />
          </>
        )}
      </button>
    </CopyToClipboard>
    <span>
      Para finalizar, basta realizar o pagamento escaneando ou colando o
      código Pix acima ou escolha Pagar com Cartão de Crédito abaixo.
    </span>
	<span><p> </p></span>

    </>
    )}

    {stripeURL && (
    <>
	<button onClick={() => window.open(stripeURL, '_blank')} type="button"
	style={{
    color: '#3c6afb', background: '#ffffff', border: '1px solid #3c6afb',
    padding: '6px 16px', fontSize: '18px', minWidth: '50%', boxSizing: 'border-box',
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif', fontWeight: '500',
    lineHeight: '1.75', borderRadius: '4px', letterSpacing: '0.02857em', textTransform: 'uppercase',
  	}}>
      Pagar Agora
    </button>
	<span><p> </p></span>
    </>
    )}

    {mercadopagoURL && (
    <>
    <button onClick={() => window.open(mercadopagoURL, '_blank')} type="button"
	style={{
    color: '#3c6afb', background: '#ffffff', border: '1px solid #3c6afb',
    padding: '6px 16px', fontSize: '18px', minWidth: '50%', boxSizing: 'border-box',
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif', fontWeight: '500',
    lineHeight: '1.75', borderRadius: '4px', letterSpacing: '0.02857em', textTransform: 'uppercase',
  	}}>
      Pagar com MercadoPago
    </button>
	<span><p> </p></span>
    </>
    )}

    {/* Asaas — cartão recorrente (destaque) */}
    {asaasCardURL && (
      <div style={{ width: '100%', marginBottom: 20 }}>
        <button
          onClick={() => window.open(asaasCardURL, '_blank')}
          type="button"
          style={{ ...btnBase, color: '#fff', background: 'linear-gradient(135deg, #3c6afb 0%, #1a4fd6 100%)', boxShadow: '0 3px 12px rgba(60,106,251,0.35)' }}
        >
          💳 Pagar Agora com Cartão
        </button>
        <div style={{
          fontSize: '0.82rem', color: '#333', lineHeight: 1.65,
          background: '#f0f4ff', borderRadius: 8, padding: '10px 14px',
          border: '1px solid #c7d6ff', textAlign: 'left'
        }}>
          <strong>✅ Opção recomendada — cobrança automática mensal</strong><br />
          Seu sistema Estratiza Hub tem automações, atendimentos e estrutura que precisam funcionar
          sem interrupção. Com o cartão de crédito, a cobrança de{' '}
          <strong>R$ {valorext && valorext.toLocaleString ? valorext.toLocaleString('pt-br', { minimumFractionDigits: 2 }) : valorext}/mês</strong>{' '}
          é feita automaticamente a cada 30 dias — você não precisa fazer nada.
          Pode cancelar quando quiser, sem multa.
        </div>
      </div>
    )}

    {/* Asaas — Pix */}
    {asaasPixURL && (
      <div style={{ width: '100%', marginBottom: 8 }}>
        <button
          onClick={() => window.open(asaasPixURL, '_blank')}
          type="button"
          style={{ ...btnBase, color: '#1a8a3a', background: '#edfdf3', border: '2px solid #1a8a3a', fontWeight: '600', fontSize: '15px', boxShadow: 'none' }}
        >
          🏧 Pagar com Pix
        </button>
        <div style={{ fontSize: '0.75rem', color: '#999', textAlign: 'center' }}>
          Pagamento via Pix. A cada vencimento será necessário renovar manualmente.
        </div>
      </div>
    )}

</SuccessContent>
    </React.Fragment>
  );
}

export default CheckoutSuccess;
